import { render, staticRenderFns } from "./DollarInCircleIcon.vue?vue&type=template&id=1ca57494"
import script from "./DollarInCircleIcon.vue?vue&type=script&lang=ts"
export * from "./DollarInCircleIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports